import { render, staticRenderFns } from "./TaskToCome.vue?vue&type=template&id=c753abc2&scoped=true&"
import script from "./TaskToCome.vue?vue&type=script&lang=js&"
export * from "./TaskToCome.vue?vue&type=script&lang=js&"
import style0 from "./TaskToCome.vue?vue&type=style&index=0&id=c753abc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c753abc2",
  null
  
)

export default component.exports